// Used as vuex store module path
const MODULE_ID = 'employee';
export default MODULE_ID;
